import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';

// O hero "Continuar" só aparece quando existe trilha pra continuar: ability
// ligada E o aluno já tem uma trilha ativa (user_learning_paths/current).
export function useHasActiveTrilha() {
  const client = useClient();
  const { abilities } = usePlatformAbilities();
  const enabled = !!abilities?.['plano-de-estudo'];
  const [hasActive, setHasActive] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    client.fetch('user_learning_paths/current').then(res => {
      if (active) setHasActive(!!res?.data);
    });
    return () => {
      active = false;
    };
  }, [enabled]);

  return enabled && hasActive;
}
